import React from 'react';
import './assets/App.css';
import './assets/AntRe.css';
import styled from 'styled-components';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import axios from 'axios';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useJsApiLoader } from '@react-google-maps/api';
import { Flex } from 'antd';
import { paths } from './consts';
import { MainTemplatePage } from './pages/MainTemplatePage';
import { MainPage } from './pages/MainPage';
import { AwardsPage } from './pages/AwardsPage';
import { LoginPage } from './pages/LoginPage';
import { API } from './common/constsAPI';
import { LIBRARIES } from './common/consts';
import './assets/fonts.css';
import { ChatPage } from './pages/ChatPage';
import { ScrollTop } from './components/ScrollTop';
import { MembershipPage } from './pages/MembershipPage';
import { MemberListingPage } from './pages/MemberListingPage';
import { MagazineItemPage } from './pages/MagazineItemPage';
import { EventPhotosPage } from './pages/EventPhotosPage';
import { PageTracker } from './components/PageTracker';
import { GISOverView } from './pages/GISOverView';
import { GISPage } from './pages/GISPage';
import { GisFaq } from './components/GisFaq';
import { GisWording } from './components/GisWordingContent';
import { GisPolicy } from './components/GisPolicy';
import { GisGuideSpecifications } from './components/GisGuideSpecifications';
import { GisFees } from './components/GisFee';
import { GisForManufacturers } from './components/GisForManufacturers';
import { GisEstimator } from './components/GisEstimator';

export const DivMinWidth = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  width: 100%
`;

export const FlexPadStyled = styled(Flex)`
  //padding: 20px 40px;
  //
  //@media (max-width: 768px) {
  //  padding: 10px 20px;
  //}
`;

function App() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: API.GOOGLE_MAPS as string,
    libraries: LIBRARIES as any[],
  });

  console.log(isLoaded);

  axios.interceptors.request.use(async (config) => {
    const headers = config.headers as any;

    if (config.url && config.url.includes(process.env.REACT_APP_REST_API!)) {
      headers['x-api-key'] = process.env.REACT_APP_API_KEY;
    }

    return config;
  }, () => {
  });

  return (
        <>
            <HelmetProvider>
                <Helmet
                    titleTemplate="%s | AWMAC BC"
                    defaultTitle="AWMAC BC">
                    <meta
                        name="description"
                        content="AWMAC - Architectural Woodwork Manufacturers Association of Canada"
                    />
                    <link rel="canonical" href='https://awmacbc.com/'/>
                </Helmet>
                <Router>
                    <PageTracker/>
                    <ScrollTop/>
                    <Routes>
                        <Route element={<MainTemplatePage />}>
                        <Route path={paths.AWARDS}
                               element={<AwardsPage/>}
                                   />
                        <Route
                            path={`${paths.AWARDS}/:section`}
                            element={
                                    <AwardsPage/>
                            }
                        />
                        <Route path={paths.CHAT}
                               element={
                                       <ChatPage/>}
                        />
                        <Route path={paths.MEMBERSHIP}
                               element={
                                       <MembershipPage/>
                                   }
                        />
                        <Route path={paths.MEMBER_LISTING}
                               element={
                                       <MemberListingPage/>
                                   }
                        />
                            <Route path={paths.GIS} element={<GISPage />}>
                                <Route index element={<GISOverView />} />
                                <Route path={paths.GIS_WORDING} element={<GisWording />} />
                                <Route path={paths.GIS_FAQ} element={<GisFaq />} />
                                <Route path={paths.GIS_POLICY} element={<GisPolicy />} />
                                <Route path={paths.GUIDE_SPECIFICATIONS} element={<GisGuideSpecifications />} />
                                <Route path={paths.GIS_FEES} element={<GisFees />} />
                                <Route path={paths.GIS_FOR_MANUFACTURERS} element={<GisForManufacturers />} />
                                <Route path={paths.GIS_ESTIMATOR} element={<GisEstimator />} />
                            </Route>
                        <Route path={`${paths.MAGAZINES}/:id`}
                               element={
                                       <MagazineItemPage/>
                                   }
                        />
                        <Route path={`${paths.EVENTS}/:year`}
                               element={
                                       <EventPhotosPage/>
                                   }
                        />
                        <Route path={paths.LOGIN}
                               element={
                                       <LoginPage/>
                               }
                        />
                        <Route path={paths.MAIN}
                               element={
                                       <MainPage/>
                               }
                        />
                        </Route>
                    </Routes>
                </Router>
            </HelmetProvider>
        </>
  );
}

export default App;
